<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <section class="mu-d-flex mu-flex-row">
                <h1 class="mu-mb-00">Email template details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00" v-if="!isCopy">
                            {{ (isNewTemplate) ? helpTextCreate.title : helpTextEdit.title }}
                            <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                        </p>
                        <p class="mu-mb-00" v-if="isCopy">
                            {{ (isCopy) ? helpTextCopy.title : helpTextEdit.title }}
                            <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>
            </section>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>
                    <a class="table-link" @click="redirectToList()">Email templates</a>
                </li>
                <li v-if="!isCopy" aria-current="page">{{ (isNewTemplate) ? 'Create new' : templateName }}
                </li>
                <li v-if="isCopy" aria-current="page">{{ copyTemplateName == '' ? 'Create new' : copyTemplateName }}</li>
            </ol>
        </nav>
        <form novalidate id="formId" @submit.prevent="saveEmailTemplate()">
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mcc-card">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                            <label class="mfc-label--required" for="name">Name</label>
                                            <input ref="name" :value="emailTemplate.name" :pattern="nameRegex" @change="updateName($event)" type="text" id="name" name="name" required="" placeholder="Name" maxlength="50">
                                        </div>
                                        <div class="mfc-textarea-wrapper mfc-form-input-container" style="width:50%;">
                                            <label for="description">Description</label>
                                            <textarea ref="description" placeholder="Description" :value="emailTemplate.description" :pattern="descRegex" @input="descriptionChanged($event)" @change="updateDescription($event)" character-count="" id="description" name="description" maxlength="100"></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <div class="mfc-help-text mu-mt-00">
                                                
                                                <span>You have {{100 - emailTemplate.description.length}} characters remaining</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mcc-card mu-mt-05">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Email editor</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mfc-textarea-wrapper mfc-form-input-container">
                                    <textarea id="templateData" name="templateData" ref="templateData" class="summernote" :value="emailTemplate.templateData" @change="emailTemplate.templateData = $event.target.value"></textarea>
                                    <div class="mfc-invalid-feedback"></div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="mu-d-flex mu-justify-content-end mu-my-05 mu-mr-06">
                        <div role="group" class="mcc-button-group mcc-button-group--spaced">
                            <router-link :to="isCopy ? CONTEXT_PATH + '/design/emailTemplates/' + templateId : CONTEXT_PATH + '/design/emailTemplates'" v-if="emailTemplate.id == null || isCopy">
                                <button type="button" class="mcc-button mcc-button--outline mu-mr-05" title="Cancel" id="emailTemplateCancelBtn">
                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                </button>
                            </router-link>
                            <button type="button" class="mcc-button mcc-button--soft-danger" v-if="showCopyDelete" @click="$refs.deleteEmailTemplateConfDialogRef.show()" title="Delete" id="deleteEmailTemplateBtn">
                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                            </button>
                            <button type="button" class="mcc-button mcc-button--outline" v-if="showCopyDelete" title="Copy" @click="copyEmailtemplate()" id="copyEmailtemplateBtn">
                                <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                            </button>
                            <button type="submit" class="mcc-button mcc-button--success" title="Save"  id="saveBtn">
                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="isDataAvailable" ref="deleteEmailTemplateConfDialogRef" id="deleteEmailTemplateConfDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete email template</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteEmailTemplateConfDialogRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            Are you sure you want to delete this template?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteEmailTemplateConfDialogRef.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDialogClose()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<style scoped></style>

<script>
import TemplateAPI from "../../../services/TemplateAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';
export default {
    name: "EmailTemplateCreate",
    data() {
        return {
            emailTemplate: {
                description: ''
            },
            updateCall: true,
            helpTextCopy: constantMessages.BREADCRUMB_HELP["emailtemplates.copy"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["emailtemplates.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["emailtemplates.edit"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            copyObj: {},
            isCopy: false,
            templateId: this.$route.params.templateId,
            templateName: '',
            isNewTemplate: false,
            showCopyDelete: false,
            isDataAvailable: false,
            copyTemplateName: '',
            isDescriptionValid: true
        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.initializeSummernote();

        if (self.$route.path.indexOf("copy") > -1) {
            self.isCopy = true;
            self.getEmailtemplate(true);
        } else if (self.$route.params.templateId != null && self.$route.params.templateId != "new") {
            self.getEmailtemplate(false);
        }
        self.isNewTemplate = self.templateId == null || self.templateId == 'new' || self.isCopy;
        self.showCopyDelete = !self.isNewTemplate && !self.isCopy;
    },
    methods: {
        descriptionChanged(e)
        {
            this.emailTemplate.description = e.target.value
            this.$forceUpdate();
        },
        updateName(event) {
            let self = this;
            if (event.target.value.length == 0) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.emailTemplate.name = event.target.value;
        },
        getEmailtemplate(isCopy) {
            let self = this;
            TemplateAPI.getTemplateData(self.$route.params.templateId).then(response => {
                if (response != null) {
                    self.isDataAvailable = true;
                    if (!isCopy) {
                        self.emailTemplate = response;
                        self.templateName = response.name;
                        $(".summernote").summernote('code', self.emailTemplate.templateData);
                        let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.emailTemplate.details"] + " - " + self.templateName;
                        EventBus.$emit("update-pageTitle", pageTitle);
                    } else {
                        self.copyObj.name = response.name;
                        self.copyObj.description = response.description;
                        self.copyObj.templateData = response.templateData;
                        $(".summernote").summernote('code', self.copyObj.templateData);
                        self.emailTemplate = self.copyObj;
                        self.emailTemplate.name = response.name + " - copy";
                        if (self.emailTemplate.name.length > 50) {
                            self.emailTemplate.name = self.emailTemplate.name.substring(0, 50);
                        }
                    }
                }
            });
        },
        initializeSummernote() {
            $('.summernote')
                .summernote({
                    height: 400,
                    callbacks: {
                        onInit: function () {
                            Utils.bindSummerNoteHintPatch();
                        },
                        onKeyup: function (e) {
                            e.stopPropagation();
                        },
                        onKeydown: function (e) {
                            if (e.keyCode == 27) {
                                return;
                            }
                            e.stopPropagation();
                        }
                    },
                    toolbar: [
                        ['style', ['style']],
                        [
                            'font',
                            ['bold', 'italic',
                                'underline',
                                'clear'
                            ]
                        ],
                        ['fontname', ['fontname']],
                        ['fontsize', ['fontsize']],
                        ['color', ['color']],
                        [
                            'para',
                            ['ul', 'ol',
                                'paragraph'
                            ]
                        ],
                        ['height', ['height']]
                    ],
                    fontSizes: ['8', '10', '12', '14',
                        '16', '18', '24', '36', '48'
                    ],
                    hint: {
                        match: /\B[$][{](\w*)$/,
                        search: function (keyword, callback) {
                            callback($
                                .grep(
                                    processVaribles,
                                    function (item) {
                                        return item
                                            .indexOf(keyword) == 0;
                                    }));
                        },
                        content: function (item) {
                            return '${' + item + '}';
                        }
                    }
                });
        },
        saveEmailTemplate() {

            let self = this;
            let form = $('#formId')

            if(!self.isDescriptionValid){
                return;
            }

            if (this.emailTemplate.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
                    {
                        return;
                    }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }     
            
            let dataVal = $(".summernote").summernote('code');
            self.emailTemplate.templateData = dataVal;
            self.emailTemplate.type = "EMAIL";
            self.updateCall = false;
            TemplateAPI.saveTemplate(
                    self.emailTemplate
                )
                .then(response => {
                    self.updateCall = true;
                    self.$refs.name.classList.remove("ms-is-invalid")
                    if (response != undefined) {
                        if (response.error) {
                            for (let k in response.messages) {
                                if (k == "name") {
                                    displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.name.classList.add("ms-is-invalid")

                                } else if (k == "description") {
                                    displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.description.classList.add("ms-is-invalid")

                                }
                            }

                        } else {
                            if (self.isNewTemplate) {
                                this.$router.push(this.CONTEXT_PATH +
                                    "/design/emailTemplates/" + response.data.id);
                            } else {
                                self.emailTemplate = response.data;
                                self.templateName = self.emailTemplate.name;
                                self.copyTemplateName = self.templateName;
                            }

                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => {});
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
        },
        handleDialogClose() {
            let self = this;
            self.$refs.deleteEmailTemplateConfDialogRef.close()
            self.updateCall = false;
            TemplateAPI.deleteTemplate(self.$route.params.templateId).then(response => {
                self.updateCall = true;
                if (response != null && response.error == false) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["message.template.emailTemplate.delete"]
                    });
                    self.$router.push(
                        self.CONTEXT_PATH + '/design/emailTemplates'
                    );
                }
            });
        },
        copyEmailtemplate() {
            let self = this;
            self.$router.push(
                self.CONTEXT_PATH + '/design/emailTemplates/' + self.emailTemplate.id + '/copy'
            );
        },
        redirectToList() {
            if (this.templateId != null && this.templateId != 0 && this.templateId != "new") {
                localStorage.setItem("emailTemplateList", "emailTemplateList");
            }

            this.$router.push(
                this.CONTEXT_PATH + '/design/emailTemplates'
            );
        }
    },
}
</script>
